import client from './apiClient';
import {
  TraceContextLogViewModel,
  TraceContextLogSummaryViewModel,
  SearchTraceLogRequest,
  AuwOrderHistorySearchRequest,
  AuwOrderHistorySearchResponse,
  AuwOrderHistoryDetailResponse,
  AuwServiceRequestHistoryViewModel,
} from '../models/auwTracing';
import { WebhookEventViewModel } from '../models/voxTracing';

export const searchTraceLogs = async (type: string = 'AUW', params: SearchTraceLogRequest = {}): Promise<TraceContextLogSummaryViewModel[]> => {
  const { data } = await client.post<TraceContextLogSummaryViewModel[]>(`/trace-logs/${type}/search`, params);
  return data;
};

export const getTraceById = async (transactionId: string): Promise<TraceContextLogViewModel[]> => {
  const { data } = await client.get<TraceContextLogViewModel[]>(`/trace-logs/${transactionId}`);
  return data;
};

export const getFileContent = async (fileRecordId: string): Promise<string> => {
  const { data } = await client.get<string>(`/files/${fileRecordId}/content`, {
    responseType: 'text',
    transformResponse: [(data) => data],
  });
  return data;
};

// ===== AUW Order History =====

export const searchAuwOrderHistory = async (
  params: AuwOrderHistorySearchRequest
): Promise<AuwOrderHistorySearchResponse[]> => {
  const { data } = await client.post<AuwOrderHistorySearchResponse[]>(
    '/auw/history/search',
    params
  );
  return data;
};

export const getAuwOrderHistoryDetail = async (
  guid: string
): Promise<AuwOrderHistoryDetailResponse> => {
  try {
    const { data } = await client.get<AuwOrderHistoryDetailResponse>(
      `/auw/history/detail/${guid}`
    );
    return data;
  } catch (error) {
    throw new Error(
      error instanceof Error ? error.message : 'Failed to load AUW order history detail'
    );
  }
};

export const getAuwOrderHistoryTraceLogs = async (
  auwOrderHistoryGuid: string
): Promise<TraceContextLogViewModel[]> => {
  const { data } = await client.get<TraceContextLogViewModel[]>(
    `/auw/history/${auwOrderHistoryGuid}/trace-logs`
  );
  return data;
};

export const getAuwOrderHistoryServiceRequests = async (
  auwOrderHistoryGuid: string
): Promise<AuwServiceRequestHistoryViewModel[]> => {
  const { data } = await client.get<AuwServiceRequestHistoryViewModel[]>(
    `/auw/history/${auwOrderHistoryGuid}/service-requests`
  );
  return data;
};

// ===== Webhook Events =====

export const resendWebhookEvent = async (
  webhookEventId: string
): Promise<WebhookEventViewModel> => {
  const { data } = await client.post<WebhookEventViewModel>(
    `/events/WebhookEvent/${webhookEventId}/resend`
  );
  return data;
};
